// // Shared JavaScript
// const html = document.documentElement;
// const body = document.body;

// // Cache commonly used elements
// const elements = {
//   header: document.querySelector('.global-header'),
//   mobileNavToggle: document.querySelector('.mobile-nav-trigger-button'),
//   searchField: document.querySelector('#search-input-field'),
//   blackout: document.querySelector('.nav-blackout'),
//   searchToggle: document.querySelector('.search-button'),
//   accordions: document.querySelectorAll('.accordion'),
//   accordionToggles: document.querySelectorAll('.accordion-toggle'),
//   navChildMenus: document.querySelectorAll('.has-child-links'),
//   navChildToggles: document.querySelectorAll('.childnav-open'),
//   navChildCloses: document.querySelectorAll('.childnav-back'),
//   modalToggles: document.querySelectorAll('.modal-toggle'),
//   closeModalToggles: document.querySelectorAll('.close-modal')
// };

// // Event delegation for mobile navigation
// document.addEventListener('click', function(e) {
//   const mobileNavToggle = e.target.closest('.mobile-nav-trigger-button');
//   if (mobileNavToggle) {
//     html.classList.toggle('mobile-menu-open');
//     html.classList.remove("nav-blackout-enabled");
//     if (elements.header) elements.header.classList.remove("search-open");
//     if (elements.searchField) elements.searchField.blur();
    
//     // Update ARIA expanded state
//     mobileNavToggle.setAttribute('aria-expanded', 
//       html.classList.contains('mobile-menu-open') ? 'true' : 'false');
//   }
// });

// // Navigation blackout effect - Event delegation
// document.addEventListener('mouseover', function(e) {
//   if (e.target.closest('.has-child-links')) {
//     html.classList.add('nav-blackout-enabled');
//     if (elements.header) elements.header.classList.remove("search-open");
//     if (elements.searchField) elements.searchField.blur();
//   }
// });

// document.addEventListener('mouseout', function(e) {
//   if (e.target.closest('.has-child-links')) {
//     html.classList.remove('nav-blackout-enabled');
//     if (elements.header) elements.header.classList.remove("search-open");
//     if (elements.searchField) elements.searchField.blur();
//   }
// });

// if (elements.blackout) {
//   elements.blackout.addEventListener('mouseover', function() {
//     html.classList.remove('nav-blackout-enabled');
//     if (elements.header) elements.header.classList.remove("search-open");
//     if (elements.searchField) elements.searchField.blur();
//   });
// }

// // Search navigation - Event delegation
// document.addEventListener('click', function(e) {
//   const searchToggle = e.target.closest('.search-button');
//   if (searchToggle) {
//     if (elements.header) elements.header.classList.add("search-open");
//     html.classList.add("nav-blackout-enabled");
//     html.classList.remove('mobile-menu-open');

//     // Make search container accessible
//     const searchContainer = document.querySelector('.header-search-container');
//     if (searchContainer) {
//       searchContainer.setAttribute('aria-hidden', 'false');
//       // Remove tabindex from search inputs
//       const searchInput = document.getElementById('search-input-field');
//       const searchSubmit = document.getElementById('search-submit');
//       if (searchInput) searchInput.removeAttribute('tabindex');
//       if (searchSubmit) searchSubmit.removeAttribute('tabindex');
//     }

//     elements.searchField.focus();
//   }
// });

// // Close search when focus moves away from search elements
// document.addEventListener('focusout', function(e) {
//   if (html.classList.contains('search-open')) {
//     // Check if the next focused element is not a search element
//     const searchElements = document.querySelectorAll('.search-button, #search-input-field, #search-submit');
//     const isSearchElement = Array.from(searchElements).some(el => el.contains(e.relatedTarget));
    
//     if (!isSearchElement) {
//       if (elements.header) elements.header.classList.remove("search-open");
//       html.classList.remove("nav-blackout-enabled");

//       // Hide search container and add tabindex back
//       const searchContainer = document.querySelector('.header-search-container');
//       if (searchContainer) {
//         searchContainer.setAttribute('aria-hidden', 'true');
//         // Add tabindex back to search inputs
//         const searchInput = document.getElementById('search-input-field');
//         const searchSubmit = document.getElementById('search-submit');
//         if (searchInput) searchInput.setAttribute('tabindex', '-1');
//         if (searchSubmit) searchSubmit.setAttribute('tabindex', '-1');
//       }
      
//       // If we're tabbing past the submit button, focus the account button
//       if (e.target.id === 'search-submit') {
//         const accountButton = document.querySelector('.account-button');
//         if (accountButton) {
//           accountButton.focus();
//         }
//       }
//     }
//   }
// });

// // Also handle ESC key to close search
// document.addEventListener('keydown', function(e) {
//   if (e.key === 'Escape' && html.classList.contains('search-open')) {
//     if (elements.header) elements.header.classList.remove("search-open");
//     html.classList.remove("nav-blackout-enabled");
    
//     // Hide search container and add tabindex back
//     const searchContainer = document.querySelector('.header-search-container');
//     if (searchContainer) {
//       searchContainer.setAttribute('aria-hidden', 'true');
//       // Add tabindex back to search inputs
//       const searchInput = document.getElementById('search-input-field');
//       const searchSubmit = document.getElementById('search-submit');
//       if (searchInput) searchInput.setAttribute('tabindex', '-1');
//       if (searchSubmit) searchSubmit.setAttribute('tabindex', '-1');
//     }
    
//     // Return focus to search button
//     const searchButton = document.querySelector('.search-button');
//     if (searchButton) searchButton.focus();
//   }
// });

// // Accordions - Event delegation
// document.addEventListener('click', function(e) {
//   const accordionToggle = e.target.closest('.accordion-toggle');
//   if (accordionToggle) {
//     const itemClass = accordionToggle.parentNode.className;
//     elements.accordions.forEach(accordion => {
//       accordion.className = 'accordion closed';
//     });
//     if (itemClass === 'accordion closed') {
//       accordionToggle.parentNode.className = 'accordion open';
//     }
//   }
// });

// Nav accordions - Event delegation
document.addEventListener('click', function(e) {
  const childNavToggle = e.target.closest('.childnav-open');
  if (childNavToggle) {
    const childNavClass = childNavToggle.parentNode.parentNode.className;
    elements.navChildMenus.forEach(menu => {
      menu.className = 'header-navigation-single has-child-links closed';
    });
    if (childNavClass === 'header-navigation-single has-child-links closed') {
      childNavToggle.parentNode.parentNode.className = 'header-navigation-single has-child-links open';
    }
  }

  const childNavClose = e.target.closest('.childnav-back');
  if (childNavClose) {
    childNavClose.parentNode.parentNode.parentNode.className = 'header-navigation-single has-child-links closed';
  }
});



// function toggleZoom(element) {
//   const zoomContainer = document.getElementById('product-media-zoom');
//   zoomContainer.classList.toggle('zoomed');

//   if (zoomContainer.classList.contains('zoomed')) {
//     const elementIndex = element.id.split('-')[1];
//     const targetElement = document.getElementById(`media-zoom-${elementIndex}`);
//     if (targetElement) {
//       // const elementTopPosition = targetElement.getBoundingClientRect().top - zoomContainer.getBoundingClientRect().top;
//       // zoomContainer.scrollTo({ top: elementTopPosition, behavior: 'instant' });
//       targetElement.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' });
//     }
//   }
// }

// // Swiper sliders
// var sliderProductImages = new Swiper('.swiper-product-images', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 'auto',
//   slidesPerGroup: 1,
//   spaceBetween: 8,
//   centeredSlidesBounds: true,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   on: {
//     click: function(swiper, event) {
//       const clickedSlide = swiper.clickedSlide;
//       if (clickedSlide) {
//         toggleZoom(clickedSlide);
//       }
//     }
//   }
// });

// var sliderProducts = new Swiper('.swiper-product-slider', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 2,
//   spaceBetween: 8,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 3,
//         spaceBetween: 12
//       },
//       1024: {
//         slidesPerView: 4,
//         spaceBetween: 16
//       }
//     }
// });

// var sliderPress = new Swiper('.swiper-press-slider', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 1,
//   spaceBetween: 8,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 2,
//         spaceBetween: 12
//       },
//       1024: {
//         slidesPerView: 3,
//         spaceBetween: 16
//       }
//     }
// });

// var sliderPressLogos = new Swiper('.subsection-press-slider', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 2,
//   spaceBetween: 0,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 4,
//         spaceBetween: 12
//       }
//     }
// });

// var sliderUGC = new Swiper('.ugc-swiper', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 2,
//   spaceBetween: 8,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 4,
//         spaceBetween: 12
//       }
//     }
// });

// var sliderBanner = new Swiper('.swiper-hero-banners', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   spaceBetween: 0,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//     768: {
//       slidesPerView: 1,
//       spaceBetween: 0
//     }
//   }
// });

// var honorRoller = new Swiper('.honor-roller-slider', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 2,
//   spaceBetween: 8,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 3,
//         spaceBetween: 12
//       },
//       1024: {
//         slidesPerView: 4,
//         spaceBetween: 16
//       }
//     }
// });

// var collectionSlider = new Swiper('.collection-slider', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 2,
//   spaceBetween: 8,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//       768: {
//         slidesPerView: 3,
//         spaceBetween: 12
//       },
//       1024: {
//         slidesPerView: 4,
//         spaceBetween: 16
//       }
//     }
// });

// var sliderLookbook = new Swiper('.swiper-lookbook', {
//   speed: 400,
//   autoplay: {
//     delay: 5000,
//     pauseOnMouseEnter: true,
//     disableOnInteraction: false
//   },
//   slidesPerView: 1,
//   spaceBetween: 16,
//   lazy: {
//     loadPrevNext: true,
//     loadPrevNextAmount: 2,
//     loadOnTransitionStart: true
//   },
//   breakpoints: {
//     768: {
//       slidesPerView: 1,
//       spaceBetween: 32
//     }
//   }
// });

// // Quantity selector
// const quantity_input = document.querySelector("#product-form").querySelector('input[name="quantity"]');
// const quantity_selector = document.getElementsByClassName('quantity-selector-option');
// for (q = 0; q < quantity_selector.length; q++) {
//   quantity_selector[q].addEventListener('click', changeQuantity, false);
// }

// function changeQuantity() {
//   var quantityValue = this.dataset.value;
//   quantity_input.value = quantityValue;

//   for (q = 0; q < quantity_selector.length; q++) {
//     quantity_selector[q].classList.remove('quantity-active');
//   }
//   this.classList.add("quantity-active");
// }

// window.addEventListener("scroll", function() {
//   var elementTarget = document.getElementById("pdp-main");
//   if (elementTarget) {  // Only proceed if element exists
//     if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
//       html.classList.add('pdp-bar-on');
//     } else {
//       html.classList.remove('pdp-bar-on');
//     }
//   }
// });

// // Social Video Slider
// var socialVideoSlider = new Swiper('.social-video-swiper', {
//   speed: 400,
//   slidesPerView: 'auto',
//   spaceBetween: 16,
//   centeredSlides: true,
//   loop: true,
//   breakpoints: {
//     768: {
//       spaceBetween: 24,
//       centeredSlides: false,
//       loop: false
//     }
//   }
// });

// // Video Play/Pause Controls
// document.addEventListener('DOMContentLoaded', function() {
//   const videoControls = document.querySelectorAll('.video-play-pause');
  
//   videoControls.forEach(control => {
//     control.addEventListener('click', function() {
//       const video = this.parentElement.querySelector('video');
//       const isPlaying = this.classList.contains('playing');
      
//       // Pause all other videos
//       document.querySelectorAll('.social-video').forEach(v => {
//         if (v !== video) {
//           v.pause();
//           v.parentElement.querySelector('.video-play-pause').classList.remove('playing');
//         }
//       });
      
//       if (isPlaying) {
//         video.pause();
//         this.classList.remove('playing');
//       } else {
//         video.play();
//         this.classList.add('playing');
//       }
//     });
//   });

//   // Pause videos when they scroll out of view
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) {
//         const video = entry.target;
//         const control = video.parentElement.querySelector('.video-play-pause');
//         video.pause();
//         control.classList.remove('playing');
//       }
//     });
//   }, { threshold: 0.5 });

//   document.querySelectorAll('.social-video').forEach(video => {
//     observer.observe(video);
//   });
// });

// // Handle keyboard navigation for navigation items
// document.addEventListener('keydown', function(e) {
//   const target = e.target;
  
//   // Handle spacebar on navigation items
//   if (e.key === ' ' || e.key === 'Spacebar') {
//     if (target.closest('.header-navigation-single-toggle')) {
//       e.preventDefault();
//       target.click();
//     }
    
//     if (target.closest('.account-button')) {
//       e.preventDefault();
//       target.click();
//     }

//     if (target.closest('.search-button')) {
//       e.preventDefault();
//       openSearch();
//     }
    
//     if (target.closest('.cart-button')) {
//       e.preventDefault();
//       target.click();
//     }
//   }

//   // Handle Tab key when search is open
//   if (e.key === 'Tab' && html.classList.contains('search-open')) {
//     const searchSubmit = document.getElementById('search-submit');
//     const accountButton = document.querySelector('.account-button');
    
//     // If we're on the submit button and tabbing forward
//     if (document.activeElement === searchSubmit && !e.shiftKey) {
//       e.preventDefault();
//       if (elements.header) elements.header.classList.remove("search-open");
//       html.classList.remove("nav-blackout-enabled");
//       if (accountButton) accountButton.focus();
//     }
//   }
// });


// // Add pause/play controls to all swiper instances
// function addSwiperPauseControls() {
//   const swiperContainers = document.querySelectorAll('.swiper-hero-banners, .swiper-product-slider, .honor-roller-slider, .collection-slider, .ugc-swiper');
  
//   swiperContainers.forEach(container => {
//     // Get the swiper instance
//     let swiperInstance = null;
//     if (container.classList.contains('swiper-hero-banners')) swiperInstance = sliderBanner;
//     else if (container.classList.contains('swiper-product-slider')) swiperInstance = sliderProducts;
//     else if (container.classList.contains('honor-roller-slider')) swiperInstance = honorRoller;
//     else if (container.classList.contains('collection-slider')) swiperInstance = collectionSlider;
//     else if (container.classList.contains('ugc-swiper')) swiperInstance = sliderUGC;

//     // Only add pause button if autoplay is enabled
//     if (swiperInstance && swiperInstance.params && swiperInstance.params.autoplay) {
//       // Create pause button
//       const pauseBtn = document.createElement('button');
//       pauseBtn.className = 'swiper-pause-button';
//       pauseBtn.setAttribute('aria-label', 'Pause slideshow');
//       pauseBtn.setAttribute('aria-pressed', 'false');
//       pauseBtn.innerHTML = '<span class="pause-icon" aria-hidden="true">⏸</span><span class="play-icon" aria-hidden="true" style="display: none;">▶</span>';
//       // Add button to container
//       container.style.position = 'relative';
//       container.appendChild(pauseBtn);
//       pauseBtn.addEventListener('click', function() {
//         const isPaused = this.getAttribute('aria-pressed') === 'true';
//         const pauseIcon = this.querySelector('.pause-icon');
//         const playIcon = this.querySelector('.play-icon');
//         if (isPaused) {
//           swiperInstance.autoplay.start();
//           this.setAttribute('aria-pressed', 'false');
//           this.setAttribute('aria-label', 'Pause slideshow');
//           pauseIcon.style.display = 'flex';
//           playIcon.style.display = 'none';
//         } else {
//           swiperInstance.autoplay.stop();
//           this.setAttribute('aria-pressed', 'true');
//           this.setAttribute('aria-label', 'Play slideshow');
//           pauseIcon.style.display = 'none';
//           playIcon.style.display = 'flex';
//         }
//       });
//     }
//   });
// }

// // Initialize pause controls after DOM is loaded
// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(addSwiperPauseControls, 100); // Small delay to ensure swipers are initialized
// });



// Shared JavaScript
const html = document.documentElement;
const body = document.body;

// Cache commonly used elements
const elements = {
  header: document.querySelector('.global-header'),
  mobileNavToggle: document.querySelector('.mobile-nav-trigger-button'),
  searchField: document.querySelector('#search-input-field'),
  blackout: document.querySelector('.nav-blackout'),
  searchToggle: document.querySelector('.search-button'),
  accordions: document.querySelectorAll('.accordion'),
  accordionToggles: document.querySelectorAll('.accordion-toggle'),
  navChildMenus: document.querySelectorAll('.has-child-links'),
  navChildToggles: document.querySelectorAll('.childnav-open'),
  navChildCloses: document.querySelectorAll('.childnav-back'),
  modalToggles: document.querySelectorAll('.modal-toggle'),
  closeModalToggles: document.querySelectorAll('.close-modal')
};

// Event delegation for mobile navigation
document.addEventListener('click', function(e) {
  const mobileNavToggle = e.target.closest('.mobile-nav-trigger-button');
  if (mobileNavToggle) {
    html.classList.toggle('mobile-menu-open');
    html.classList.remove("nav-blackout-enabled");
    if (elements.header) elements.header.classList.remove("search-open");
    if (elements.searchField) elements.searchField.blur();
    
    // Update ARIA expanded state
    mobileNavToggle.setAttribute('aria-expanded', 
      html.classList.contains('mobile-menu-open') ? 'true' : 'false');
  }
});

// Navigation blackout effect - Event delegation
document.addEventListener('mouseover', function(e) {
  if (e.target.closest('.has-child-links')) {
    html.classList.add('nav-blackout-enabled');
    if (elements.header) elements.header.classList.remove("search-open");
    if (elements.searchField) elements.searchField.blur();
  }
});

document.addEventListener('mouseout', function(e) {
  if (e.target.closest('.has-child-links')) {
    html.classList.remove('nav-blackout-enabled');
    if (elements.header) elements.header.classList.remove("search-open");
    if (elements.searchField) elements.searchField.blur();
  }
});

if (elements.blackout) {
  elements.blackout.addEventListener('mouseover', function() {
    html.classList.remove('nav-blackout-enabled');
    if (elements.header) elements.header.classList.remove("search-open");
    if (elements.searchField) elements.searchField.blur();
  });
}

// Search navigation - Event delegation
document.addEventListener('click', function(e) {
  const searchToggle = e.target.closest('.search-button');
  if (searchToggle) {
    if (elements.header) elements.header.classList.add("search-open");
    html.classList.add("nav-blackout-enabled");
    html.classList.remove('mobile-menu-open');

    // Make search container accessible
    const searchContainer = document.querySelector('.header-search-container');
    if (searchContainer) {
      searchContainer.setAttribute('aria-hidden', 'false');
      // Remove tabindex from search inputs
      const searchInput = document.getElementById('search-input-field');
      const searchSubmit = document.getElementById('search-submit');
      if (searchInput) searchInput.removeAttribute('tabindex');
      if (searchSubmit) searchSubmit.removeAttribute('tabindex');
    }

    elements.searchField.focus();
  }
});

// Close search when focus moves away from search elements
document.addEventListener('focusout', function(e) {
  if (html.classList.contains('search-open')) {
    const searchElements = document.querySelectorAll('.search-button, #search-input-field, #search-submit');
    const isSearchElement = Array.from(searchElements).some(el => el.contains(e.relatedTarget));
    
    if (!isSearchElement) {
      if (elements.header) elements.header.classList.remove("search-open");
      html.classList.remove("nav-blackout-enabled");

      // Hide search container and add tabindex back
      const searchContainer = document.querySelector('.header-search-container');
      if (searchContainer) {
        searchContainer.setAttribute('aria-hidden', 'true');
        const searchInput = document.getElementById('search-input-field');
        const searchSubmit = document.getElementById('search-submit');
        if (searchInput) searchInput.setAttribute('tabindex', '-1');
        if (searchSubmit) searchSubmit.setAttribute('tabindex', '-1');
      }

      if (e.target.id === 'search-submit') {
        const accountButton = document.querySelector('.account-button');
        if (accountButton) {
          accountButton.focus();
        }
      }
    }
  }
});

// Also handle ESC key to close search
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && html.classList.contains('search-open')) {
    if (elements.header) elements.header.classList.remove("search-open");
    html.classList.remove("nav-blackout-enabled");
    
    const searchContainer = document.querySelector('.header-search-container');
    if (searchContainer) {
      searchContainer.setAttribute('aria-hidden', 'true');
      const searchInput = document.getElementById('search-input-field');
      const searchSubmit = document.getElementById('search-submit');
      if (searchInput) searchInput.setAttribute('tabindex', '-1');
      if (searchSubmit) searchSubmit.setAttribute('tabindex', '-1');
    }
    
    const searchButton = document.querySelector('.search-button');
    if (searchButton) searchButton.focus();
  }
});

// Scroll event to handle adding/removing classes
window.addEventListener("scroll", function() {
  var elementTarget = document.getElementById("pdp-main");
  if (elementTarget) {  // Only proceed if element exists
    if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
      html.classList.add('pdp-bar-on');
    } else {
      html.classList.remove('pdp-bar-on');
    }
  }
});

// Video Play/Pause Controls
document.addEventListener('DOMContentLoaded', function() {
  const videoControls = document.querySelectorAll('.video-play-pause');
  
  videoControls.forEach(control => {
    control.addEventListener('click', function() {
      const video = this.parentElement.querySelector('video');
      const isPlaying = this.classList.contains('playing');
      
      // Pause all other videos
      document.querySelectorAll('.social-video').forEach(v => {
        if (v !== video) {
          v.pause();
          v.parentElement.querySelector('.video-play-pause').classList.remove('playing');
        }
      });
      
      if (isPlaying) {
        video.pause();
        this.classList.remove('playing');
      } else {
        video.play();
        this.classList.add('playing');
      }
    });
  });

  // Pause videos when they scroll out of view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        const video = entry.target;
        const control = video.parentElement.querySelector('.video-play-pause');
        video.pause();
        control.classList.remove('playing');
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.social-video').forEach(video => {
    observer.observe(video);
  });
});

// Handle keyboard navigation for navigation items
document.addEventListener('keydown', function(e) {
  const target = e.target;
  
  // Handle spacebar on navigation items
  if (e.key === ' ' || e.key === 'Spacebar') {
    if (target.closest('.header-navigation-single-toggle')) {
      e.preventDefault();
      target.click();
    }
    
    if (target.closest('.account-button')) {
      e.preventDefault();
      target.click();
    }

    if (target.closest('.search-button')) {
      e.preventDefault();
      target.click();
    }
    
    if (target.closest('.cart-button')) {
      e.preventDefault();
      target.click();
    }
  }

  // Handle Tab key when search is open
  if (e.key === 'Tab' && html.classList.contains('search-open')) {
    const searchSubmit = document.getElementById('search-submit');
    const accountButton = document.querySelector('.account-button');
    
    // If we're on the submit button and tabbing forward
    if (document.activeElement === searchSubmit && !e.shiftKey) {
      e.preventDefault();
      if (elements.header) elements.header.classList.remove("search-open");
      html.classList.remove("nav-blackout-enabled");
      if (accountButton) accountButton.focus();
    }
  }
});

// // Modals - Event delegation
document.addEventListener('click', function(e) {
  const modalToggle = e.target.closest('.modal-toggle');
  if (modalToggle) {
    const modalTarget = modalToggle.dataset.modaltarget;
    html.classList.add('modal-on');
    const modalTargetEl = document.getElementById(modalTarget);
    modalTargetEl.classList.add("enabled");
    
//     // Update ARIA attributes
    modalTargetEl.setAttribute('aria-hidden', 'false');
    modalTargetEl.setAttribute('aria-modal', 'true');
    
//     // Store the element that opened the modal
    modalTargetEl.dataset.previousFocus = modalToggle.id;
    
//     // Focus the first focusable element in the modal
    const focusableElements = modalTargetEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    } else {
      modalTargetEl.focus();
    }

//     // Add keyboard event listener for focus trapping
    modalTargetEl.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        const focusableElements = modalTargetEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      } else if (e.key === 'Escape') {
        closeModal(modalTargetEl);
      }
    });
  }

  const closeModalToggle = e.target.closest('.close-modal');
  if (closeModalToggle) {
    const modalTarget = closeModalToggle.dataset.modaltarget;
    const modalTargetEl = document.getElementById(modalTarget);
    closeModal(modalTargetEl);
  }
});

function closeModal(modalEl) {
  html.classList.remove('modal-on');
  modalEl.classList.remove("enabled");
  
  // Update ARIA attributes
  modalEl.setAttribute('aria-hidden', 'true');
  modalEl.setAttribute('aria-modal', 'false');
  
  const previousFocus = modalEl.dataset.previousFocus;
  if (previousFocus) {
    const previousFocusEl = document.getElementById(previousFocus);
    if (previousFocusEl) {
      previousFocusEl.focus();
    }
  }
}

// Initialize Swipers
document.addEventListener("DOMContentLoaded", function () {
  if (!window.Swiper) return; // Swiper loads conditionally (see theme.liquid); bail cleanly on templates without it
  var swiperComplementary = new Swiper("[data-complementary_products_v2]", {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        spaceBetween: 10
      },
      1024: {
        spaceBetween: 20
      }
    }
  });

  var swiperComplementary = new Swiper(".complementary-products-section [data-complementary_products]", {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        spaceBetween: 10
      },
      1024: {
        spaceBetween: 20
      }
    }
  });

  // PDP gallery: one markup, Swiper carousel on mobile (<48rem) only; CSS grid on desktop.
  // Swiper is built/destroyed at the 48rem boundary so its inline styles don't fight the grid.
  (function () {
    var galleryEl = document.querySelector(".swiper-product-images");
    if (!galleryEl) return; // non-PDP pages: bail, no error

    var mq = window.matchMedia("(max-width: 47.99rem)"); // mobile = strictly below the 48rem grid breakpoint
    var swiperProductMedia = null;

    function buildProductSwiper() {
      if (swiperProductMedia) return; // idempotent
      swiperProductMedia = new Swiper(".swiper-product-images", {
        speed: 400,
        // AUTOPLAY DISABLED 2026-09-09 FOR THE NEW-PDP A/B TEST. RESTORE AFTERWARDS (or decide to
        // keep it off). Reason: the rebuilt PDP's gallery has no autoplay, so with this on, the two
        // arms' "how far through the gallery did they get" numbers measure different things — this
        // one advances itself to the last image in ~45s whether or not anyone is looking, which
        // would show control at near-100% completion on a metric that had recorded no human
        // behaviour at all. With it off, every slide change in BOTH arms is user-driven.
        // Plan: docs/AB TEST/PDP/new-pdp-ab-test-plan.md
        // autoplay: {
        //   delay: 5000,
        //   pauseOnMouseEnter: true,
        //   disableOnInteraction: true
        // },
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 8,
        centeredSlidesBounds: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true
        }
        // on.click removed — zoom is handled by the single delegated listener below
      });
    }

    function killProductSwiper() {
      if (!swiperProductMedia) return;
      swiperProductMedia.destroy(true, true); // cleanStyles: strip inline transform/width so grid CSS takes over
      swiperProductMedia = null;
    }

    function syncProductSwiper(e) {
      if (e.matches) buildProductSwiper();
      else killProductSwiper();
    }

    syncProductSwiper(mq); // initial state on load
    if (mq.addEventListener) mq.addEventListener('change', syncProductSwiper);
    else mq.addListener(syncProductSwiper); // older Safari fallback

    // Single zoom-open path — works whether Swiper is on (mobile) or off (desktop), no double-fire.
    galleryEl.addEventListener('click', function (e) {
      var item = e.target.closest('[data-media-item]');
      if (item) toggleZoom(item); // item carries id="media-N" for toggleZoom's index lookup
    });
  })();

  var sliderProducts = new Swiper('.swiper-product-slider', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: true
    },
    slidesPerView: 2,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  });

  // Play the product slider only while it is on screen; pause when scrolled away.
  if (sliderProducts && sliderProducts.el && sliderProducts.autoplay) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // document.body.style.backgroundColor = 'black'; // debug: visualize play trigger
          sliderProducts.autoplay.start();
        } else {
          // document.body.style.backgroundColor = ''; // debug: visualize pause trigger
          sliderProducts.autoplay.stop();
        }
      });
    }, { threshold: 0 }).observe(sliderProducts.el);
  }

  var sliderPress = new Swiper('.swiper-press-slider', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 1,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
  });

  var sliderPressLogos = new Swiper('.subsection-press-slider', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 2,
    spaceBetween: 0,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
  });

  var sliderUGC = new Swiper('.ugc-swiper', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 2,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
  });

  var sliderBanner = new Swiper('.swiper-hero-banners', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    spaceBetween: 0,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });

  var honorRoller = new Swiper('.honor-roller-slider', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 2,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  });

  var collectionSlider = new Swiper('.collection-slider', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 2,
    spaceBetween: 8,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
  });

  var sliderLookbook = new Swiper('.swiper-lookbook', {
    speed: 400,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    slidesPerView: 1,
    spaceBetween: 16,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      loadOnTransitionStart: true
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 32
      }
    }
  });

  // Social Video Slider
  var socialVideoSlider = new Swiper('.social-video-swiper', {
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      768: {
        spaceBetween: 24,
        centeredSlides: false,
        loop: false
      }
    }
  });
});


